import { render, staticRenderFns } from "./FrameAssemblyPriceTableDialog.vue?vue&type=template&id=ba33fca4&scoped=true"
import script from "./FrameAssemblyPriceTableDialog.vue?vue&type=script&lang=ts"
export * from "./FrameAssemblyPriceTableDialog.vue?vue&type=script&lang=ts"
import style0 from "./FrameAssemblyPriceTableDialog.vue?vue&type=style&index=0&id=ba33fca4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba33fca4",
  null
  
)

export default component.exports